<template>
  <div class="d-timetal" :class="{'d-timetal--read-only': isReadOnly}">
    <div class="d-timetal__container">
      <h4 class="uppercase">Undervisning i specialklasser</h4>
      <table class="d-table">
        <thead>
        <tr>
          <th></th>
          <th v-for="grade in grades" :key="grade.value">{{ grade.title }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="fag in fagMedVProps" :key="fag.fagkode" v-if="!isReadOnly">
          <td>{{ fag.title }}</td>
          <td v-for="klasse in fag.klasser"
              :class="[{'td-is-obligatorisk': klasse.v_obligatorisk}, {'td-is-checkbox': klasse.hasOwnProperty('checkbox')}]">
            <input type="number" class="d-input" v-if="klasse.hasOwnProperty('num')"
                   :value="klasse.num" @blur="updateCell(klasse.v_originalObject, $event.target.value)">
            <div v-if="klasse.hasOwnProperty('checkbox') && fag._type === 'konfirmation'"
                 @click="setKonfirmation(fag.v_fag, klasse.value)"
                 class="d-checkbox"
                 :class="{'d-checkbox--active': fag.v_fag.klassetrin * 1 === klasse.value * 1}">
            </div>
            <div v-if="klasse.hasOwnProperty('checkbox') && fag._type === 'praktik'"
                 @click="setPraktik(fag)"
                 class="d-checkbox"
                 :class="{'d-checkbox--active': fag.praktikkode === 'J'}">
            </div>
          </td>
        </tr>
        <tr class="d-summarized">
          <td>Obligatorisk fagopdelt undervisning i alt</td>
          <td v-for="timer in obligatoriskFagopdelt">{{ timer }}</td>
        </tr>
        <tr class="d-summarized d-explainer">
          <td>Minimumstimetal</td>
          <td v-for="(num, key) in minimumFagopdelt">({{ num }})</td>
        </tr>
        <tr class="d-summarized">
          <td>Øvrig fagopdelt undervisning i alt</td>
          <td v-for="timer in ovrigFagopdelt">{{ timer }}</td>
        </tr>
        <tr v-for="uuvfag in uuv" v-if="!isReadOnly">
          <td>{{ uuvfag.title }}</td>
          <td v-for="klasse in uuvfag.klasser">
            <input type="number" class="d-input"
                   v-if="klasse.hasOwnProperty('num')"
                   :value="klasse.num"
                   @blur="updateCell(klasse.v_originalObject, $event.target.value)">
          </td>
        </tr>
        <tr class="d-summarized">
          <td>Skoleårets samlede længde
            (= Obligatorisk fagopdelt undervisning
            + øvrige fag + Understøttende undervisning)
          </td>
          <td v-for="timer in sammentaelling">{{ timer }}</td>
        </tr>
        <tr class="d-summarized d-explainer">
          <td>Mindstekrav til skoleårets samlede længde</td>
          <td v-for="(num, key) in totalMinimum">
            <span v-if="num > 0">({{ num }})</span>
          </td>
        </tr>
        <tr v-for="tolaerer in tolaererArr">
          <td>{{ tolaerer.title }}</td>
          <td v-for="klasse in tolaerer.klasser" class="td-is-checkbox">
            <div @click="setTolaerer(klasse)"
                 class="d-checkbox"
                 :class="{'d-checkbox--active': klasse && klasse.godkendelseskode && klasse.godkendelseskode === 'J'}">
            </div>
          </td>
        </tr>
        <tr v-for="foranstaltning in foranstaltningerMedProps">
          <td>{{ foranstaltning.title }}</td>
          <td v-for="klasse in foranstaltning.klasser" class="td-is-checkbox">
            <div @click="setForanstaltning(klasse)"
                 class="d-checkbox"
                 :class="{'d-checkbox--active': klasse && klasse.godkendelseskode && klasse.godkendelseskode === 'J'}">
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    undervisningskema: {
      type: Array,
      default: () => []
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fag: [
        {
          _type: 'undervisningstid', fagkode: '600', title: 'Børnehaveklasse', klasser: [],
          obligatorisk: {0: true}
        },
        {
          _type: 'undervisningstid',
          fagkode: '110',
          title: 'Dansk',
          klasser: [],
          obligatorisk: {1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true}
        },
        {
          _type: 'undervisningstid', fagkode: '181', title: 'Historie', klasser: [],
          obligatorisk: {3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true}
        },
        {
          _type: 'undervisningstid', fagkode: '310', title: 'Matematik', klasser: [],
          obligatorisk: {1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true}
        },
        {
          _type: 'undervisningstid', fagkode: '799', title: 'Øvrige fag', klasser: [],
          obligatorisk: {}
        }
      ],
      klasstype: {
        40: 'Normalklasse',
        50: 'Specialklasse'
      },
      grades: [
        {value: '1', title: '1.'},
        {value: '2', title: '2.'},
        {value: '3', title: '3.'},
        {value: '4', title: '4.'},
        {value: '5', title: '5.'},
        {value: '6', title: '6.'},
        {value: '7', title: '7.'},
        {value: '8', title: '8.'},
        {value: '9', title: '9.'}
      ],
      minimumFagopdelt: {
        1: 750,
        2: 780,
        3: 810,
        4: 870,
        5: 930,
        6: 930,
        7: 960,
        8: 990,
        9: 990
      },
      totalMinimum: {
        1: 1110,
        2: 1110,
        3: 1110,
        4: 1320,
        5: 1320,
        6: 1320,
        7: 1400,
        8: 1400,
        9: 1400
      },
      understottende: [
        {
          _type: 'undervisningstid',
          fagkode: '800',
          title: 'Understøttende undervisning i alt inkl. alle pauser',
          klasser: []
        }
      ],
      tolaererOrdning: [
        {
          _type: 'tolaerer',
          godkendelsestype: 'b',
          title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i specialklasser jf. §16b?',
          klasser: []
        },
        {
          _type: 'tolaerer',
          godkendelsestype: 'd',
          title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i specialklasser jf. §16d?',
          klasser: []
        }
      ],
      foranstaltninger: [{
        _type: 'foranstaltninger',
        title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i specialklasser jf. §16e?',
        klasser: []
      }]
    }
  },
  computed: {
    fagFraStil () {
      return this.undervisningskema.filter(skema => skema._type === 'undervisningstid' && skema.klassetype === '50')
    },
    foranstaltningerFraStil () {
      return this.undervisningskema.filter(skema => skema._type === 'foranstaltninger' && skema.klassetype === '50')
    },
    foranstaltningerMedProps () {
      return this.foranstaltninger.map(foranstaltning => {
        foranstaltning.klasser = []
        this.grades.forEach(grade => {
          const idx = this.foranstaltningerFraStil.findIndex(faget => faget.klassetrin * 1 === grade.value * 1)
          foranstaltning.klasser.push(this.foranstaltningerFraStil[idx])
        })
        return foranstaltning
      })
    },
    tolaerer () {
      //  _type:"tolaerer", godkendelseskode:"N", godkendelsestype:"b", klassetrin:0, klassetype:"40"
      return this.undervisningskema.filter(skema => skema._type === 'tolaerer' && skema.klassetype === '50')
    },
    tolaererArr () {
      return this.tolaererOrdning.map(toLaerer => {
        const arr = this.tolaerer.filter(obj => obj.godkendelsestype === toLaerer.godkendelsestype)
        toLaerer.klasser = []
        this.grades.forEach(grade => {
          const idx = arr.findIndex(faget => faget.klassetrin * 1 === grade.value * 1)
          toLaerer.klasser.push(arr[idx])
        })
        return toLaerer
      })
    },
    sammentaelling () {
      const fag = this.fagMedVProps.filter(fag => fag._type === 'undervisningstid')
      let hoursInGrades = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0
      }
      fag.forEach(hvertFag => {
        hvertFag.klasser.forEach((klasse, key) => {
          if (klasse && klasse.num) {
            const prop = klasse.v_originalObject.klassetrin
            hoursInGrades[prop] += klasse.num
          }
        })
      })
      this.uuv.forEach(uuv => {
        uuv.klasser.forEach((uuvKlasse, key) => {
          if (uuvKlasse && uuvKlasse.num) {
            const prop = uuvKlasse.v_originalObject.klassetrin
            hoursInGrades[prop] += uuvKlasse.num
          }
        })
      })
      return hoursInGrades
    },
    uuv () {
      return this.understottende.map(fag => {
        fag.v_originalObject = this.fagFraStil[this.fagFraStil.findIndex(faget => faget.fagkode === fag.fagkode)]
        fag.klasser = []
        this.grades.forEach(grade => {
          fag.klasser.push(this.findGradeAndHours(fag, grade.value, '50'))
        })
        return fag
      })
    },
    obligatoriskFagopdelt () {
      const fag = this.fagMedVProps.filter(fag => fag._type === 'undervisningstid')
      let hoursInGrades = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0
      }
      fag.forEach(hvertFag => {
        hvertFag.klasser.forEach((klasse, key) => {
          if (klasse && klasse.num && (klasse.v_obligatorisk || key === 10)) {
            const klassetrin = klasse.v_originalObject.klassetrin
            hoursInGrades[klassetrin] += klasse.num
          }
        })
      })
      return hoursInGrades
    },
    ovrigFagopdelt () {
      const fag = this.fagMedVProps.filter(fag => fag._type === 'undervisningstid')
      let hoursInGrades = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0
      }
      fag.forEach(hvertFag => {
        hvertFag.klasser.forEach((klasse, key) => {
          if (klasse && klasse.num && !klasse.v_obligatorisk && key !== 10) {
            const klassetrin = klasse.v_originalObject.klassetrin
            hoursInGrades[klassetrin] += klasse.num
          }
        })
      })
      return hoursInGrades
    },
    kristendom () {
      return this.undervisningskema[this.undervisningskema.findIndex(skema => skema._type === 'konfirmation')]
    },
    fagMedVProps () {
      return this.fag.map(fag => {
        if (fag._type === 'undervisningstid') {
          fag.v_fag = this.fagFraStil[this.fagFraStil.findIndex(faget => faget.fagkode === fag.fagkode)]
          fag.klasser = []
          this.grades.forEach(grade => {
            fag.klasser.push(this.findGradeAndHours(fag, grade.value, '50'))
          })
        }
        if (fag._type === 'konfirmation') {
          fag.klasser = []
          fag.v_fag = this.undervisningskema[this.undervisningskema.findIndex(skema => skema._type === 'konfirmation')]
          this.grades.forEach(grade => {
            if (grade.value === '7' || grade.value === '8') {
              fag.klasser.push({checkbox: true, value: grade.value})
            } else {
              fag.klasser.push(false)
            }
          })
        }
        if (fag._type === 'praktik') {
          fag.v_fag = this.undervisningskema[this.undervisningskema.findIndex(skema => skema._type === 'praktik')]
          fag.klasser = []
          fag.praktikkode = fag.v_fag.praktikkode
          this.grades.forEach(grade => {
            if (grade.value === '10') {
              fag.klasser.push({checkbox: true, value: fag.v_fag.praktikkode})
            } else {
              fag.klasser.push(false)
            }
          })
        }
        return fag
      })
    }
  },
  methods: {
    findToLaererAndHours (arr, klassetrin) {
      const idx = arr.findIndex(faget => faget.klassetrin * 1 === klassetrin * 1)
      if (idx > -1) {
        return {num: arr[idx]['godkendelseskode'], v_originalObject: arr[idx]}
      } else {
        return false
      }
    },
    setPraktik (fag) {
      this.$emit('updatePraktik', fag)
    },
    setTolaerer (fag) {
      this.$emit('setTolaerer', fag)
    },
    setForanstaltning (foranstaltning) {
      this.$emit('setForanstaltning', foranstaltning)
    },
    updateCell (originalObject, value) {
      const obj = {originalObject, value, toUpdate: 'klokketimer'}
      this.$emit('update', obj)
    },
    setKonfirmation (fag, klasse) {
      // const val = klasse === fag.klassetrin ? '' : klasse
      const obj = {v_fag: fag, value: klasse}
      this.$emit('updateKonfirmation', obj)
    },
    findGradeAndHours (fag, klassetrin, klassetype) {
      const idx = this.fagFraStil.findIndex(faget => faget.klassetype === klassetype && faget.fagkode === fag.fagkode && faget.klassetrin * 1 === klassetrin * 1)
      const self = this

      function getIsObligatorisk () {
        if (fag.fagkode === '170') {
          return fag.obligatorisk && fag.obligatorisk[klassetrin] && self.kristendom && self.kristendom['klassetrin'] * 1 !== klassetrin * 1
        }
        return fag.obligatorisk && fag.obligatorisk[klassetrin]
      }

      if (idx > -1) {
        return {
          num: this.fagFraStil[idx]['klokketimer'],
          v_originalObject: this.fagFraStil[idx],
          v_obligatorisk: getIsObligatorisk()
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.uppercase {
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  max-width: 1440px;
  min-width: 1100px;
  border-radius: 4px;
}

.d-table {
  width: 100%;
  border: 1px solid #d8d8d8;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-table thead {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table thead th,
.d-table tbody td {
  padding: 0.5rem 1rem;
  text-align: left;
  width: 75px !important;
}

.d-table thead tr th:first-child {
  border-radius: 4px 0 0 0;
}

.d-table thead tr th:first-child,
.d-table tbody tr td:first-child {
  width: 200px !important;
}

.d-table tbody tr {
  width: 100%;
  background: #f9fafb;
  border-bottom: 1px solid #e3e8ee;
}

.d-table tbody tr:hover {
  background: aliceblue;
}

.d-table thead th {
  text-align: center;
}

input.d-input {
  outline: 0 !important;
  border: 1px solid #edf2f7;
  padding: 0.75rem 1rem;
  width: 100%;
  font-size: .85rem;
  margin: 0;
  -webkit-appearance: none !important;
  background-color: rgb(255, 255, 255);
  box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(64 68 82 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(64 68 82 / 8%) 0px 2px 5px 0px;
  box-sizing: border-box !important;
  transition: background-color .24s, box-shadow .24s;
  border-radius: 4px;
  text-align: center;
}

input.d-input:focus {
  border-color: var(--blue) !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
  -webkit-appearance: none !important;
}

.td-is-checkbox {
  text-align: center !important;
}

.td-is-checkbox .d-checkbox {
  margin: 0 auto !important;
  cursor: pointer;
}

.d-timetal--read-only .td-is-checkbox .d-checkbox {
  cursor: not-allowed;
}

.d-checkbox:before,
.d-checkbox:after {
  background: transparent;
}

.d-checkbox--active.d-checkbox:before,
.d-checkbox--active.d-checkbox:after {
  background: #ffffff;
}

.d-checkbox:not(.d-checkbox--active):before,
.d-checkbox:after:not(.d-checkbox--active) {
  background: transparent;
}

.d-summarized {
  font-weight: bold;
  font-size: 1.05rem;
  background: #eee !important;
}

tr.d-summarized td:not(:first-child) {
  text-align: center;
}

.d-summarized.d-explainer {
  font-weight: normal;
  font-style: italic;
  font-size: 0.95rem;
}

.td-is-obligatorisk input[type="number"] {
  border-color: green !important;
}
</style>



// WEBPACK FOOTER //
// GrundskoleIndberetningTimetalFagSpecial.vue?386e6e31